import { render, staticRenderFns } from "./componente-vendaproduto.vue?vue&type=template&id=ef51a142"
import script from "./componente-vendaproduto.vue?vue&type=script&lang=js"
export * from "./componente-vendaproduto.vue?vue&type=script&lang=js"
import style0 from "./componente-vendaproduto.vue?vue&type=style&index=0&id=ef51a142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports